<app-stages [stages]='stages' currentStage='Dane identyfikacyjne'>
</app-stages>
<br>
@if (!pending() && !loading()) {
  <form novalidate autocomplete='off' [formGroup]='form' (ngSubmit)="submitAndGoNext()">
    <br>
    <div class='row'>
      <div class='col-12'>
        <div class='form-group' *ngIf='"isFiledByProxy" as controlName'>
          <div class='custom-checkbox custom-inline'
               [ngClass]='{ "is-invalid": form.showError(controlName) }'>
            <input
              (change)="form.isFiledByProxyChange()"
              [formControlName]='controlName'
              type='checkbox'
              [id]='controlName'
              [name]='controlName'>
            <label [for]='controlName'>
              Składam wniosek przez pełnomocnika
            </label>
          </div>
          <app-validation-errors [control]='form.isFiledByProxy'>
          </app-validation-errors>
        </div>
      </div>
    </div>
    @if (form.isFiledByProxy.value) {
      <app-proxy-form [form]='form.proxyPersonForm'>
      </app-proxy-form>
      <br>
    }
    <div class='form-actions top flex-column flex-md-row' *ngIf="!form.isFiledByProxy.value">
      <button type='button' class='btn btn-secondary' (click)='onPastDataFromLoginGov()'>
        <i class='fa fa-paste' aria-hidden='true'></i>
        Wczytaj dane z Profilu zaufanego
      </button>
      <button type='button' class='btn btn-secondary' (click)='onPastDataFromPortal()'>
        <i class='fa fa-paste' aria-hidden='true'></i>
        Wczytaj dane z Portalu e-usług
      </button>
    </div>
    <fieldset>
      <legend>
        Dane identyfikacyjne podatnika
      </legend>
      <div class="row">
        @if (form.applicantType) {
          <div class="col-12">
            <p id="applicantTypeDesc" class="pb-3">
              Rodzaj podatnika *:
            </p>
            <div class="form-group" *ngIf='"applicantType" as controlName'>
              <div class="custom-radio custom-inline">
                <input aria-labelledby="applicantTypeDesc"
                       [name]="controlName"
                       [formControlName]='controlName'
                       value="Osoba prawna"
                       type="radio"
                       [id]="controlName + 'LegalEntity'">
                <label [for]="controlName + 'LegalEntity'">
                  Osoba prawna
                </label>
              </div>
              <div class="custom-radio custom-inline">
                <input aria-labelledby="applicantTypeDesc"
                       [name]="controlName"
                       [formControlName]='controlName'
                       value="Jednostka organizacyjna, w tym spółka nieposiadająca osobowości prawnej"
                       type="radio"
                       [id]="controlName + 'OrgUnit'">
                <label [for]="controlName + 'OrgUnit'">
                  Jednostka organizacyjna, w tym spółka nieposiadająca osobowości prawnej
                </label>
              </div>
            </div>
          </div>
        }
        <div class="col-12">
          <p id="identifierTypeDesc" class="pb-3">
            Typ identyfikatora podatnika *:
          </p>
          <div class="form-group" *ngIf='"identifierType" as controlName'>
            @if (form.entityType.value === entityTypes.OSOBA_FIZYCZNA) {
              <div class="custom-radio custom-inline">
                <input aria-labelledby="identifierTypeDesc"
                       [name]="controlName"
                       [formControlName]='controlName'
                       type="radio"
                       [id]="controlName + 'PESEL'"
                       value="PESEL">
                <label [for]="controlName + 'PESEL'">
                  PESEL
                </label>
              </div>
            }
            <div class="custom-radio custom-inline">
              <input aria-labelledby="identifierTypeDesc"
                     [name]="controlName"
                     [formControlName]='controlName'
                     value="NIP"
                     type="radio"
                     [id]="controlName + 'NIP'">
              <label [for]="controlName + 'NIP'">
                NIP
              </label>
            </div>
            @if (form.entityType.value === entityTypes.OSOBA_PRAWNA) {
              <div class="custom-radio custom-inline">
                <input aria-labelledby="identifierTypeDesc"
                       [name]="controlName"
                       [formControlName]='controlName'
                       value="REGON"
                       type="radio"
                       [id]="controlName + 'REGON'">
                <label [for]="controlName + 'REGON'">
                  REGON
                </label>
              </div>
            }
            @if (form.entityType.value === entityTypes.OSOBA_FIZYCZNA) {
              <div class="custom-radio custom-inline">
                <input aria-labelledby="identifierTypeDesc"
                       [name]="controlName"
                       [formControlName]='controlName'
                       value="Nie został mi nadany NIP i PESEL"
                       type="radio"
                       [id]="controlName + 'NO_NIP_AND_PESEL'">
                <label [for]="controlName + 'NO_NIP_AND_PESEL'">
                  Nie został mi nadany NIP i PESEL
                </label>
              </div>
            }
          </div>
        </div>
      </div>
      @switch (form.identifierType.value) {
        @case ('PESEL') {
          <app-applicant-pesel-data-form [form]="form">
          </app-applicant-pesel-data-form>
        }
        @case ('NIP') {
          <app-applicant-nip-data-form [form]="form">
          </app-applicant-nip-data-form>
        }
        @case ('REGON') {
          <app-applicant-regon-data-form [form]="form">
          </app-applicant-regon-data-form>
        }
        @default {
          <app-applicant-no-nip-and-pesel-data-form [form]="form">
          </app-applicant-no-nip-and-pesel-data-form>
        }
      }
    </fieldset>
    <fieldset>
      <legend>
        Adres zamieszkania
      </legend>
      <app-applicant-address-data-form [form]="form">
      </app-applicant-address-data-form>
    </fieldset>
    <fieldset>
      <legend>
        Kontakt
      </legend>
      <div class="row">
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"phone" as controlName'>
            <label [for]='controlName'>
              Numer telefonu
            </label>
            <input
              mask='0*'
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu dodatkowy numer telefonu'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"email" as controlName'>
            <label [for]='controlName'>
              E-mail
            </label>
            <input
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu e-mail'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    </fieldset>
    <div class='application-actions'>
      <button type='button' class='btn btn-secondary' (click)='onCancel()'>
          <span>
            Wstecz
          </span>
      </button>
      <button
        [disabled]='!serviceType() || pending()'
        type='submit'
        class='btn btn-primary'>
        <span>Zapisz i przejdź dalej</span>
      </button>
    </div>
  </form>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
